<div class="pm-container">

  <!-- Close -->
  <button class="pm-close" type="button" (click)="activeModal.dismiss()">
    <i class="fa-solid fa-xmark"></i>
  </button>

  <!-- Icon -->
  <div class="pm-icon">
    <i class="fa-solid fa-crown"></i>
  </div>

  <!-- Content -->
  <h2 class="pm-title" translate>Contenu Premium</h2>
  <p class="pm-subtitle" translate>
    Cette section est réservée aux abonnements BOOST et PRO.
  </p>
  <p class="pm-desc" translate>
    Débloquez l'intégralité du contenu et progressez sans limite en passant à la formule supérieure.
  </p>

  <!-- Actions -->
  <div class="pm-actions">
    <button class="pm-btn-upgrade" type="button" (click)="openUpgrade()" translate>
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
      Gérer mon abonnement
    </button>
    <button class="pm-btn-cancel" type="button" (click)="activeModal.dismiss()" translate>
      Pas maintenant
    </button>
  </div>

</div>
